<!-- eslint-disable max-len -->
<nz-tabset
  nzCentered
  (nzSelectedIndexChange)="onChangeTab($event)"
  style="border-bottom: none"
  qa="editWindow"
>
  <nz-tab
    nzTitle="General"
    style="overflow-y: scroll !important; overflow-x: hidden !important"
  >
  </nz-tab>
  <nz-tab
    nzTitle="Endpoint & Stats"
    style="overflow-y: scroll !important; overflow-x: hidden !important"
  >
  </nz-tab>
  <nz-tab
    nzTitle="Filters & Scanners"
    style="overflow-y: scroll !important; overflow-x: hidden !important"
  >
  </nz-tab>
  <nz-tab
    *ngIf="editSspService.isVastConnection()"
    nzTitle="VAST Extensions"
    style="overflow-y: scroll !important; overflow-x: hidden !important"
  >
  </nz-tab>
  <nz-tab
    nzTitle="Others"
    style="overflow-y: scroll !important; overflow-x: hidden !important"
  >
  </nz-tab>
</nz-tabset>
<form class="ssp-form-edit" [formGroup]="editSspService.editSSPForm">
  <div class="platform-form endpoint-edit-form">
    <div class="card-container">
      <div>
        <div class="row" *ngIf="editSspService.tabIndex === 0">
          <div class="col-6">
            <div class="form-group">
              <label for="endpointSSPNameEdit">Name *</label>
              <input
                id="endpointSSPNameEdit"
                nz-input
                type="text"
                required
                name="name"
                formControlName="name"
                class="form-control"
                (input)="onValidateSpaceForName()"
              />
            </div>
            <div class="form-group">
              <label class="label-title">Connection Type</label>
              <div class="conn-type">
                <div
                  class="item active"
                  *ngIf="editSspService.isRTBConnection()"
                >
                  RTB
                </div>
                <div
                  class="item active"
                  *ngIf="editSspService.isVastConnection()"
                >
                  VAST
                </div>
                <div
                  class="item active"
                  *ngIf="editSspService.isJSConnection()"
                >
                  JS
                </div>
                <div
                  class="item active"
                  *ngIf="editSspService.isPreBidConnection()"
                >
                  Prebid
                </div>
                <div
                  class="item active"
                  *ngIf="editSspService.isPrebidJsConnection()"
                >
                  Prebid.js
                </div>
              </div>
            </div>
            <div class="form-group" *ngIf="editSspService.isRTBConnection()">
              <label>RTB Connection</label>
              <div class="btn-group btn-group--rtb">
                <label
                  [class.active]="
                    editSspService.formValue.rtbConnectionMode === 0
                  "
                >
                  RTB to ALL
                  <input
                    type="radio"
                    name="rtbConnectionMode"
                    formControlName="rtbConnectionMode"
                    [checked]="editSspService.formValue.rtbConnectionMode === 0"
                    [value]="0"
                  />
                </label>
                <label
                  [class.active]="
                    editSspService.formValue.rtbConnectionMode === 2
                  "
                >
                  RTB to RTB
                  <input
                    type="radio"
                    name="rtbConnectionMode"
                    formControlName="rtbConnectionMode"
                    [checked]="editSspService.formValue.rtbConnectionMode === 2"
                    [value]="2"
                  />
                </label>
                <label
                  [class.active]="
                    editSspService.formValue.rtbConnectionMode === 1
                  "
                >
                  RTB to VAST
                  <input
                    type="radio"
                    name="rtbConnectionMode"
                    formControlName="rtbConnectionMode"
                    [checked]="editSspService.formValue.rtbConnectionMode === 1"
                    [value]="1"
                  />
                </label>
                <label
                  [class.active]="
                    editSspService.formValue.rtbConnectionMode === 3
                  "
                >
                  RTB to JS
                  <input
                    type="radio"
                    name="rtbConnectionMode"
                    formControlName="rtbConnectionMode"
                    [checked]="editSspService.formValue.rtbConnectionMode === 3"
                    [value]="3"
                  />
                </label>
              </div>
            </div>
            <div class="form-group" *ngIf="editSspService.isVastConnection()">
              <label>VAST Connection</label>
              <div class="btn-group btn-group--vast">
                <label
                  [class.active]="
                    editSspService.formValue.vastConnectionMode === 0
                  "
                >
                  VAST to ALL
                  <input
                    type="radio"
                    formControlName="vastConnectionMode"
                    [value]="0"
                    [checked]="
                      editSspService.formValue.vastConnectionMode === 0
                    "
                  />
                </label>
                <label
                  [class.active]="
                    editSspService.formValue.vastConnectionMode === 2
                  "
                >
                  VAST to RTB
                  <input
                    type="radio"
                    formControlName="vastConnectionMode"
                    [value]="2"
                    [checked]="
                      editSspService.formValue.vastConnectionMode === 2
                    "
                  />
                </label>
                <label
                  [class.active]="
                    editSspService.formValue.vastConnectionMode === 1
                  "
                >
                  VAST to VAST
                  <input
                    type="radio"
                    formControlName="vastConnectionMode"
                    [value]="1"
                    [checked]="
                      editSspService.formValue.vastConnectionMode === 1
                    "
                  />
                </label>
              </div>
            </div>
            <div
              *ngIf="
                editSspService.isRTBConnection() ||
                editSspService.isPreBidConnection() ||
                editSspService.isPrebidJsConnection()
              "
            >
              <div class="form-title form-title--checkbox">Ad Format</div>
              <div class="form-group form-group_chb form-group_check">
                <div class="custom-checkbox" id="adFormat">
                  <div class="checkbox">
                    <label
                      checkboxLabel="bannerFormatSSPEdit"
                      nz-checkbox
                      formControlName="isBanner"
                      [ngClass]="
                        editSspService.isRequiredTrafficType
                          ? 'required-label'
                          : 'fake-label'
                      "
                      (ngModelChange)="onChangeChecked($event, 'isBanner')"
                      name="isBanner"
                      >Banner</label
                    >
                  </div>
                  <div class="checkbox">
                    <label
                      checkboxLabel="nativeFormatSSPEdit"
                      nz-checkbox
                      (ngModelChange)="onChangeChecked($event, 'isNative')"
                      [ngClass]="
                        editSspService.isRequiredTrafficType
                          ? 'required-label'
                          : 'fake-label'
                      "
                      formControlName="isNative"
                      name="isNative"
                      >Native</label
                    >
                  </div>
                  <div class="checkbox">
                    <label
                      checkboxLabel="videoFormatSSPEdit"
                      nz-checkbox
                      (ngModelChange)="onChangeChecked($event, 'isVideo')"
                      [ngClass]="
                        editSspService.isRequiredTrafficType
                          ? 'required-label'
                          : 'fake-label'
                      "
                      formControlName="isVideo"
                      name="isVideo"
                      >Video</label
                    >
                  </div>
                  <div class="checkbox">
                    <label
                      checkboxLabel="rewardedFormatSSPEdit"
                      nz-checkbox
                      (ngModelChange)="onChangeChecked($event, 'rewarded')"
                      [ngClass]="
                        editSspService.isRequiredTrafficType
                          ? 'required-label'
                          : 'fake-label'
                      "
                      formControlName="rewarded"
                      [nzDisabled]="
                        editSspService.formValue['isAudio'] ||
                        editSspService.isPrebidJsConnection()
                      "
                      name="rewarded"
                      >Rewarded video</label
                    >
                  </div>
                  <div
                    class="checkbox"
                    *ngIf="!editSspService.isPreBidConnection()"
                  >
                    <label
                      checkboxLabel="audioFormatSSPEdit"
                      nz-checkbox
                      (ngModelChange)="onChangeChecked($event, 'isAudio')"
                      [ngClass]="
                        editSspService.isRequiredTrafficType
                          ? 'required-label'
                          : 'fake-label'
                      "
                      formControlName="isAudio"
                      [nzDisabled]="
                        editSspService.formValue['ctv'] ||
                        editSspService.formValue['rewarded'] ||
                        editSspService.isPrebidJsConnection()
                      "
                      name="isAudio"
                      >Audio</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <hr
              *ngIf="
                editSspService.isRTBConnection() ||
                editSspService.isPreBidConnection() ||
                editSspService.isPrebidJsConnection()
              "
            />
            <div
              class="form-group form-group_chb rtb-ad-types"
              *ngIf="
                editSspService.isRTBConnection() ||
                editSspService.isPreBidConnection() ||
                editSspService.isPrebidJsConnection()
              "
            >
              <div class="form-title form-title--traffic">Traffic type</div>
              <div class="custom-checkbox" id="trafficType">
                <div class="checkbox">
                  <label
                    checkboxLabel="mobileWebTrafficTypeSSPEdit"
                    nz-checkbox
                    [ngClass]="
                      editSspService.isRequiredTrafficType
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="mobile_web"
                    name="mobile_web"
                    >Mobile web</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="mobileAppTrafficTypeSSPEdit"
                    nz-checkbox
                    [ngClass]="
                      editSspService.isRequiredTrafficType
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="mobile_app"
                    [nzDisabled]="editSspService.isPrebidJsConnection()"
                    name="mobile_app"
                    >Mobile app</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="desktopTrafficTypeSSPEdit"
                    nz-checkbox
                    [ngClass]="
                      editSspService.isRequiredTrafficType
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="desktop"
                    name="desktop"
                    >Desktop</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="ctvTrafficTypeSSPEdit"
                    nz-checkbox
                    [ngClass]="
                      editSspService.isRequiredTrafficType
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="ctv"
                    [nzDisabled]="
                      editSspService.formValue['isAudio'] ||
                      editSspService.isPrebidJsConnection()
                    "
                    name="ctv"
                    >CTV</label
                  >
                </div>
              </div>
            </div>
            <hr
              *ngIf="
                editSspService.isRTBConnection() ||
                editSspService.isPreBidConnection() ||
                editSspService.isPrebidJsConnection()
              "
            />
            <div *ngIf="editSspService.isVastConnection()">
              <div class="form-title form-title--checkbox">Ad Format</div>
              <div class="form-group form-group_chb form-group_check">
                <div class="hub-row">
                  <div class="hub-part" id="adFormat">
                    <div class="checkbox">
                      <label
                        checkboxLabel="videoVastFormatSSPEdit"
                        nz-checkbox
                        [ngClass]="
                          editSspService.isRequiredAdFormat
                            ? 'required-label'
                            : 'fake-label'
                        "
                        formControlName="isVideo"
                        [nzDisabled]="
                          editSspService.formValue['isAudio'] ||
                          editSspService.formValue['rewarded']
                        "
                        name="isVideo"
                        >Video</label
                      >
                    </div>
                    <div class="checkbox">
                      <label
                        checkboxLabel="rewardedVideoFormatSSPVastJS"
                        nz-checkbox
                        [ngClass]="
                          editSspService.isRequiredAdFormat
                            ? 'required-label'
                            : 'fake-label'
                        "
                        formControlName="rewarded"
                        name="rewarded"
                        [nzDisabled]="
                          editSspService.formValue['isVideo'] ||
                          editSspService.formValue['isAudio']
                        "
                        >Rewarded video</label
                      >
                    </div>
                    <div class="checkbox">
                      <label
                        checkboxLabel="audioVastFormatSSPEdit"
                        nz-checkbox
                        [ngClass]="
                          editSspService.isRequiredAdFormat
                            ? 'required-label'
                            : 'fake-label'
                        "
                        formControlName="isAudio"
                        [nzDisabled]="
                          editSspService.formValue['isVideo'] ||
                          editSspService.formValue['rewarded']
                        "
                        name="isAudio"
                        >Audio</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr *ngIf="editSspService.isVastConnection()" />
            <div
              class="form-group form-radio"
              *ngIf="editSspService.isVastConnection()"
              id="trafficType"
            >
              <label class="form-title form-title--traffic"
                >Traffic Type

                <app-tooltip
                  [tooltipTitle]="
                    'Choose whether the endpoint works according to RTB specifications or VAST.'
                  "
                ></app-tooltip>
              </label>
              <div class="ad-types">
                <div
                  class="radio-50"
                  checkboxLabel="mobileWebTrafficTypeVastSSPEdit"
                >
                  <label class="custom-radio">
                    Mobile web
                    <input
                      formControlName="adtype"
                      type="radio"
                      name="adtype"
                      value="mobile_web"
                      (ngModelChange)="onChangeTrafficType($event)"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div
                  class="radio-50"
                  checkboxLabel="desktopTrafficTypeVastSSPEdit"
                >
                  <label class="custom-radio">
                    Desktop
                    <input
                      formControlName="adtype"
                      type="radio"
                      name="adtype"
                      value="desktop"
                      (ngModelChange)="onChangeTrafficType($event)"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="ad-types">
                <div
                  class="radio-50"
                  checkboxLabel="mobileAppTrafficTypeVastSSPEdit"
                >
                  <label class="custom-radio">
                    Mobile app
                    <input
                      formControlName="adtype"
                      type="radio"
                      name="adtype"
                      value="mobile_app"
                      (ngModelChange)="onChangeTrafficType($event)"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="radio-50" checkboxLabel="ctvTrafficTypeVastSSPEdit">
                  <label class="custom-radio ml-20">
                    CTV
                    <input
                      formControlName="adtype"
                      type="radio"
                      name="adtype"
                      value="ctv"
                      (ngModelChange)="onChangeTrafficType($event)"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
            <hr *ngIf="editSspService.isVastConnection()" />
            <div
              class="form-group form-radio"
              *ngIf="editSspService.isJSConnection()"
              id="trafficType"
            >
              <label
                >Traffic Type
                <app-tooltip
                  [tooltipTitle]="
                    'Choose whether the endpoint works according to RTB specifications or VAST.'
                  "
                ></app-tooltip>
              </label>
              <div class="ad-types">
                <div
                  class="radio-50"
                  checkboxLabel="mobileWebTrafficTypeJsSSPEdit"
                >
                  <label class="custom-radio">
                    Mobile web
                    <input
                      formControlName="jsAdType"
                      type="radio"
                      name="jsAdType"
                      value="mobile_web"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div
                  class="radio-50"
                  checkboxLabel="desktopTrafficTypeJsSSPEdit"
                >
                  <label class="custom-radio">
                    Desktop
                    <input
                      formControlName="jsAdType"
                      type="radio"
                      name="jsAdType"
                      value="desktop"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="ad-types">
                <div
                  class="radio-50"
                  checkboxLabel="mobileAppTrafficTypeJsSSPEdit"
                >
                  <label class="custom-radio">
                    Mobile app
                    <input
                      formControlName="jsAdType"
                      type="radio"
                      name="jsAdType"
                      value="mobile_app"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
            <hr *ngIf="editSspService.isJSConnection()" />
          </div>
          <div class="col-6">
            <div
              class="form-group"
              *ngIf="editSspService.isVastConnection()"
              formGroupName="vast"
            >
              <label for="bidfloorSSPEdit">
                Fixed Bidfloor *
                <app-tooltip
                  tooltipTitle="The value entered here is used as the fixed payout to SSP partners. This value represents the cost per thousand impressions (CPM). The minimal Fixed Bidfloor value is 0.01."
                ></app-tooltip>
              </label>
              <div class="ssp-limit">
                <input
                  id="bidfloorSSPEdit"
                  nz-input
                  class="form-control"
                  required
                  name="bidfloor"
                  formControlName="bidfloor"
                  qa="bidfloor"
                  min="0.01"
                />
              </div>
            </div>

            <div
              class="form-group"
              *ngIf="editSspService.isVastConnection()"
              formGroupName="vast"
            >
              <label>Sizes </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Size"
                formControlName="selectedSizes"
                (ngModelChange)="sizeChange($event)"
                name="sizes"
              >
                <nz-option
                  *ngFor="let size of editSspService.sizesList"
                  [nzValue]="size.id"
                  [nzLabel]="size.name"
                ></nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              *ngIf="
                editSspService.isVastConnection() &&
                editSspService.selectedSizesControl.value === '1'
              "
              formGroupName="vast"
            >
              <div class="row b-row dsp-api-link-wrap">
                <div class="col-6">
                  <label>Width</label>
                  <input
                    id="customWidthVastSSPEdit"
                    nz-input
                    type="text"
                    name="w"
                    formControlName="w"
                    required
                    class="form-control"
                  />
                </div>
                <div class="col-6">
                  <label>Height</label>
                  <input
                    id="customHeightVastSSPEdit"
                    nz-input
                    type="text"
                    name="h"
                    formControlName="h"
                    required
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="label-title"
                >Company*
                <app-tooltip
                  [tooltipTitle]="'A company to which endpoint belongs'"
                ></app-tooltip>
              </label>
              <nz-select
                [ngClass]="
                  editSspService.isRequiredCompany
                    ? 'required-company'
                    : 'company'
                "
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Company"
                (ngModelChange)="onCompanyChange()"
                formControlName="companyId"
                name="companyId"
              >
                <nz-option
                  *ngFor="let company of editSspService.companies"
                  [nzValue]="company.id"
                  [nzLabel]="company.name"
                >
                </nz-option>
              </nz-select>
            </div>
            <div class="form-group">
              <label class="label-title"
                >Region*
                <app-tooltip
                  [tooltipTitle]="
                    'Region in which server capacities are located'
                  "
                ></app-tooltip>
              </label>
              <nz-select
                [nzDisabled]="true"
                name="region"
                [ngClass]="
                  editSspService.isRequiredRegion ? 'required-region' : 'region'
                "
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Region"
                formControlName="region"
              >
                <nz-option
                  *ngFor="let region of editSspService.regions"
                  [nzValue]="region.id"
                  [nzLabel]="region.name"
                ></nz-option>
              </nz-select>
            </div>
            <div class="form-group">
              <label for="margin_type">Margin Type</label>
              <div class="margin-group">
                <nz-radio-group
                  formControlName="margin_type"
                  name="margin_type"
                  nzButtonStyle="solid"
                  (ngModelChange)="onChangeMarginType($event)"
                >
                  <label nz-radio-button nzValue="fixed">Fixed</label>
                  <label
                    nz-radio-button
                    nzValue="adaptive"
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      editSspService.restrictionTooltipMessage(
                        'Adaptive margin type'
                      )
                    "
                    nzTooltipPlacement="top"
                    [nzDisabled]="
                      editSspService.partnerSettings.partner_plan === 3
                    "
                    >Adaptive</label
                  >
                  <label
                    nz-radio-button
                    nzValue="range"
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      editSspService.restrictionTooltipMessage(
                        'Range margin type'
                      )
                    "
                    nzTooltipPlacement="top"
                    [nzDisabled]="
                      editSspService.partnerSettings.partner_plan === 3
                    "
                    >Range</label
                  >
                </nz-radio-group>
              </div>
              <div
                class="margin"
                *ngIf="editSspService.formValue['margin_type'] === 'fixed'"
              >
                <label class="label-title" for="marginSSPEdit"
                  >Margin*
                  <app-tooltip
                    [tooltipTitle]="
                      'Percent that the platform charges from the endpoint revenue'
                    "
                  ></app-tooltip>
                </label>
                <input
                  id="marginSSPEdit"
                  class="form-control"
                  nz-input
                  type="number"
                  name="margin"
                  min="0"
                  max="100"
                  formControlName="margin"
                  placeholder="15 %"
                  required
                />
              </div>
              <div
                class="adavanced-settings"
                *ngIf="editSspService.formValue['margin_type'] === 'range'"
              >
                <div class="clearfix">
                  <div class="part left alt">
                    <div class="form-group">
                      <label for="minMarginSSPEdit">Min Margin*</label>
                      <input
                        id="minMarginSSPEdit"
                        class="form-control"
                        nz-input
                        type="number"
                        name="min_margin"
                        min="1"
                        max="100"
                        formControlName="min_margin"
                        placeholder="1 %"
                        required
                      />
                    </div>
                  </div>
                  <div class="part right alt">
                    <div class="form-group">
                      <label for="maxMarginSSPEdit">Max Margin*</label>
                      <input
                        id="maxMarginSSPEdit"
                        class="form-control"
                        nz-input
                        type="number"
                        name="max_margin"
                        min="1"
                        max="100"
                        formControlName="max_margin"
                        placeholder="100 %"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="label-title" for="spendLimitSSPEdit">
                Spend Limit
                <span *ngIf="editSspService.isJSConnection()">*</span>
                <app-tooltip
                  [tooltipTitle]="'Maximum allowed spending on this endpoint'"
                ></app-tooltip>
              </label>
              <div class="ssp-limit">
                <input
                  id="spendLimitSSPEdit"
                  nz-input
                  type="number"
                  class="form-control"
                  name="spendLimit"
                  [required]="editSspService.isJSConnection()"
                  formControlName="spendLimit"
                />
              </div>
            </div>
            <div
              class="form-group"
              *ngIf="editSspService.isJSConnection()"
              formGroupName="js"
            >
              <label for="jsBidfloorSSPEdit">
                Fixed Bidfloor*
                <app-tooltip
                  tooltipTitle="The value entered here is used as the fixed payout to SSP partners. This value represents the cost per thousand impressions (CPM). The minimal Fixed Bidfloor value is 0.01."
                ></app-tooltip>
              </label>
              <div class="ssp-limit">
                <input
                  id="jsBidfloorSSPEdit"
                  nz-input
                  type="number"
                  class="form-control"
                  name="jsBidfloor"
                  min="0"
                  max="100"
                  required
                  formControlName="bidfloor"
                  qa="bidfloor"
                  min="0"
                />
              </div>
            </div>
            <div class="adavanced-settings">
              <div class="clearfix">
                <div
                  [ngClass]="
                    editSspService.isVastConnection()
                      ? 'vast-tmax'
                      : 'part left alt'
                  "
                >
                  <div class="form-group">
                    <label for="defaultTmaxSSPEdit">Default tmax</label>
                    <input
                      id="defaultTmaxSSPEdit"
                      nz-input
                      class="form-control"
                      name="defaultTmax"
                      formControlName="defaultTmax"
                    />
                  </div>
                </div>
                <div
                  class="part right alt"
                  *ngIf="!editSspService.isVastConnection()"
                >
                  <div class="form-group">
                    <label class="label-title" for="defaultBidfloorSSPEdit"
                      >Default bidfloor
                      <app-tooltip
                        [tooltipTitle]="
                          'This value applied when bidfloor field in a request is empty'
                        "
                      ></app-tooltip>
                    </label>
                    <input
                      id="defaultBidfloorSSPEdit"
                      nz-input
                      type="number"
                      class="form-control"
                      name="defaultBidfloor"
                      formControlName="defaultBidfloor"
                      [disabled]="editSspService.fixedBidPriceControl.value"
                      qa="bidfloor"
                    />
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="editSspService.isJSConnection()">
              <hr />
              <div class="form-title form-title--size">Size</div>
              <div class="form-group">
                <label>Size</label>
                <nz-select
                  nzShowSearch
                  nzPlaceHolder="Select Size"
                  formControlName="selectedSize"
                  (ngModelChange)="onChangeSize($event)"
                  name="size-select"
                >
                  <nz-option
                    *ngFor="let size of editSspService.listOfSizes"
                    [nzValue]="size.id"
                    [nzLabel]="size.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
              <div class="form-group" formGroupName="js">
                <div class="row b-row dsp-api-link-wrap">
                  <div class="col-6">
                    <label>Width*</label>
                    <input
                      id="customWidthJsSSPEdit"
                      nz-input
                      type="text"
                      name="w"
                      formControlName="w"
                      required
                      class="form-control"
                    />
                  </div>
                  <div class="col-6">
                    <label>Height*</label>
                    <input
                      id="customHeightJsSSPEdit"
                      nz-input
                      type="text"
                      name="h"
                      formControlName="h"
                      required
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group" formGroupName="js">
                <label for="backfillSSPEdit">Backfill</label>
                <textarea
                  id="backfillSSPEdit"
                  nz-input
                  class="form-control"
                  name="backfill"
                  formControlName="backfill"
                ></textarea>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="row" *ngIf="editSspService.tabIndex === 1">
          <div
            class="col-12"
            *ngIf="
              editSspService.isRTBConnection() ||
              editSspService.isVastConnection() ||
              editSspService.isJSConnection()
            "
          >
            <div class="row b-row" *ngIf="editSspService.isJSConnection()">
              <div class="col-12">
                <div class="form-group" formGroupName="js">
                  <label>JS Tag Type</label>
                  <nz-select
                    nzShowSearch
                    nzPlaceHolder
                    formControlName="tagType"
                    [id]="editSspService.formValue.js.tagType"
                    (ngModelChange)="onTagTypeChanged($event)"
                  >
                    <nz-option
                      *ngFor="let tag of editSspService.jsTagTypes"
                      [nzValue]="tag.id"
                      [nzLabel]="tag.name"
                    ></nz-option>
                  </nz-select>
                </div>
              </div>
            </div>
            <div class="form-group endpoint-link">
              <div class="row b-row dsp-api-link-wrap">
                <div class="col-9">
                  <label
                    for="test-api-link"
                    *ngIf="!editSspService.isJSConnection()"
                    >{{
                      editSspService.connectionTypesNames[
                        editSspService.formValue.connectionType
                      ]
                    }}</label
                  >
                  <label *ngIf="editSspService.isJSConnection()">JS Tag</label>
                  <textarea
                    id="endpointUrlSSPEdit"
                    nz-input
                    class="form-control endpointUrl"
                    [disabled]="true"
                    name="endpointUrl"
                    formControlName="endpoint"
                  ></textarea>
                </div>
                <div class="col-3">
                  <button
                    buttonLabel="copyEndpointUrlSSPEdit"
                    nz-button
                    type="button"
                    nzType="default"
                    class="test-link-button"
                    (click)="onCopyLink($event, 'Copied Endpoint')"
                    [cbContent]="editSspService.endpointControl.value"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="editSspService.isJSConnection()">
              <div class="macros-group" *ngIf="editSspService.isShowJSMacros">
                <div class="col-9">
                  <div class="form-group" formGroupName="js">
                    <nz-select
                      nzShowSearch
                      nzPlaceHolder="Select Macros"
                      [nzShowArrow]="true"
                      (ngModelChange)="onChangeMacrosJs($event)"
                      formControlName="macrosList"
                      nzMode="multiple"
                      name="macrosJs"
                    >
                      <nz-option
                        *ngFor="let macros of editSspService.macrosListJs"
                        [nzValue]="macros.id"
                        [nzLabel]="macros.name"
                      >
                      </nz-option>
                    </nz-select>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <button
                      nz-button
                      nzType="default"
                      class="btn-macros"
                      (click)="onShowMacrosList()"
                    >
                      Macros List
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-group endpoint-link"
              *ngIf="editSspService.isVastConnection()"
              formGroupName="vast"
            >
              <div class="row b-row dsp-api-link-wrap">
                <div class="col-9">
                  <nz-select
                    nzShowSearch
                    [nzShowArrow]="true"
                    nzPlaceHolder="Select Macros"
                    formControlName="macrosList"
                    name="macros"
                    (ngModelChange)="onChangeVastMacros($event)"
                    nzMode="multiple"
                    [nzMaxTagCount]="15"
                    [nzMaxTagPlaceholder]="tagPlaceHolder"
                  >
                    <nz-option
                      *ngFor="let macros of editSspService.macrosListVast"
                      [nzValue]="macros.id"
                      [nzLabel]="macros.name"
                    >
                    </nz-option>
                  </nz-select>
                  <ng-template #tagPlaceHolder let-omittedValues
                    >and {{ omittedValues.length }} more...</ng-template
                  >
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <button
                      nz-button
                      nzType="default"
                      class="btn-macros"
                      (click)="onShowMacrosList()"
                    >
                      Macros List
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="
                editSspService.isRTBConnection() && editSspService.adaptersItem
              "
              class="col-12"
            >
              <div class="form-group">
                <label>
                  Custom Adapter
                  <app-tooltip
                    [tooltipTitle]="'API adapters list'"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzShowSearch
                  nzPlaceHolder="Select Custom Adapter"
                  formControlName="adapter_id"
                  name="selectedAdapters"
                  (ngModelChange)="onChangeCustomAdapter($event)"
                >
                  <nz-option
                    *ngFor="let adapter of editSspService.rtbAdapters"
                    [nzValue]="adapter.id"
                    [nzLabel]="adapter.name"
                    [nzDisabled]="adapter.disabled"
                    nzCustomContent
                  >
                    <span
                      nz-tooltip
                      nzTooltipOverlayClassName="item-tooltip"
                      [nzTooltipTitle]="
                        editSspService.getTooltipForHuaweiAdapter(adapter.name)
                      "
                      nzTooltipPlacement="top"
                      >{{ adapter.name }}
                    </span>
                  </nz-option>
                </nz-select>
              </div>
              <div class="block-fields" *ngIf="editSspService.isShowFields">
                <h3 class="prebid-header">Additional Adapters Fields</h3>
                <div
                  class="form-group"
                  *ngFor="let item of editSspService.adaptersRtb; let i = index"
                >
                  <label
                    >{{ item.name }}
                    <span *ngIf="isRequiredAdapterField(item.name)"> * </span>
                    <app-tooltip
                      *ngIf="item.tooltip"
                      [tooltipTitle]="item.tooltip"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    [(ngModel)]="item.field"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="
                      editSspService.adaptersItem.config.paramsReq[item.name]
                        .required
                    "
                  />
                </div>
              </div>
            </div>
            <div>
              <div
                class="form-group"
                *ngIf="editSspService.isShowImpTriggering"
              >
                <label>Impression triggering</label>
                <nz-select
                  nzPlaceHolder="Select Impression triggering"
                  formControlName="imp_triggering"
                  name="imp_triggering"
                >
                  <nz-option
                    *ngFor="
                      let impTriggeringItem of editSspService.impTriggeringItems
                    "
                    [nzValue]="impTriggeringItem.id"
                    [nzLabel]="impTriggeringItem.name"
                  ></nz-option>
                </nz-select>
              </div>
              <div class="form-group">
                <div class="row b-row">
                  <div class="col-9" name="platformStatsApi">
                    <label for="sspStatisticApiLinkSSPEdit"
                      >SSP's Statistic API link</label
                    >
                    <input
                      id="sspStatisticApiLinkSSPEdit"
                      nz-input
                      type="text"
                      class="form-control"
                      name="sspApiUrl"
                      formControlName="apiLink"
                      (change)="
                        onValidateLink(
                          editSspService.formValue['apiLink'],
                          $event
                        )
                      "
                    />
                    <app-check-endpoint-status
                      [endpointValidationStatuses]="
                        editSspService.apiLinkValidationStatus
                      "
                      [apilink]="editSspService.apiLink"
                      [side]="'ssp'"
                      [endpointId]="editSspService.formValue['id']"
                      (hasError)="getError($event)"
                    ></app-check-endpoint-status>
                    <small>replace date with a placeholder [%Y-m-d%]</small>
                  </div>
                  <div class="col-3">
                    <button
                      buttonLabel="sspStatisticApiLinkTestSSPEdit"
                      nz-button
                      nzType="default"
                      class="test-link-button"
                      (click)="
                        onApiLinkTest(
                          editSspService.formValue['apiLink'],
                          $event
                        )
                      "
                      [disabled]="editSspService.isDisabledTest"
                    >
                      Test
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row b-row dsp-api-link-wrap">
                  <div class="col-9" name="platformStats">
                    <label>Platform Statistics API link</label>
                    <textarea
                      id="platformStatisticApiLinkSSPEdit"
                      nz-input
                      [disabled]="true"
                      formControlName="reportingApiLink"
                      class="form-control"
                      name="sspApiUrl"
                    ></textarea>
                    <small>replace date with a placeholder [%Y-m-d%]</small>
                  </div>
                  <div class="col-3">
                    <button
                      buttonLabel="platformStatisticApiLinkCopySSPEdit"
                      nz-button
                      nzType="default"
                      type="button"
                      class="test-link-button"
                      (click)="onCopyLink($event, 'Copy API link')"
                      [cbContent]="editSspService.formValue['reportingApiLink']"
                      ngxClipboard
                    >
                      Copy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="editSspService.isPreBidConnection()">
            <div
              class="form-group"
              *ngIf="editSspService.isShowPartnerNameForPrebid"
            >
              <div class="prebid__row">
                <div class="prebid__input">
                  <label for="partnerNameSSPEdit">Partner name</label>
                  <input
                    id="partnerNameSSPEdit"
                    nz-input
                    class="form-control"
                    [disabled]="true"
                    [name]="editSspService.formValue['partnerName']"
                    formControlName="partnerName"
                  />
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="partnerNameCopySSPEdit"
                    nz-button
                    nzType="default"
                    type="button"
                    class="test-link-button"
                    (click)="onCopyLink($event, 'Copied Partner name')"
                    [cbContent]="editSspService.formValue['partnerName']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="prebid__row">
                <div class="prebid__input">
                  <label for="seatSSPEdit">Seat</label>
                  <input
                    id="seatSSPEdit"
                    nz-input
                    class="form-control"
                    [disabled]="true"
                    formControlName="seat"
                    [name]="editSspService.formValue['seat']"
                  />
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="seatCopySSPEdit"
                    nz-button
                    nzType="default"
                    type="button"
                    class="test-link-button"
                    (click)="onCopyLink($event, 'Copied seat')"
                    [cbContent]="editSspService.formValue['seat']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="prebid__row">
                <div class="prebid__input">
                  <label for="tokenSSPEdit">Token</label>
                  <input
                    id="tokenSSPEdit"
                    nz-input
                    class="form-control"
                    [disabled]="true"
                    formControlName="secretKey"
                    [name]="editSspService.formValue['secretKey']"
                  />
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="tokenCopySSPEdit"
                    nz-button
                    nzType="default"
                    type="button"
                    class="test-link-button"
                    (click)="onCopyLink($event, 'Copied token')"
                    [cbContent]="editSspService.formValue['secretKey']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="prebid__row">
                <div class="prebid__input" name="platformStats">
                  <label for="sspStatisticApiLinkSSPEdit"
                    >SSP's Statistics API link</label
                  >
                  <input
                    id="sspStatisticApiLinkSSPEdit"
                    nz-input
                    type="text"
                    class="form-control"
                    name="sspApiUrl"
                    formControlName="apiLink"
                    (change)="
                      onValidateLink(
                        editSspService.formValue['apiLink'],
                        $event
                      )
                    "
                  />
                  <app-check-endpoint-status
                    [endpointValidationStatuses]="
                      editSspService.apiLinkValidationStatus
                    "
                    [apilink]="editSspService.apiLink"
                    [side]="'ssp'"
                    (hasError)="getError($event)"
                    [endpointId]="editSspService.formValue['id']"
                  ></app-check-endpoint-status>
                  <small class="replace"
                    >replace date with a placeholder [%Y-m-d%]</small
                  >
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="sspStatisticApiLinkTestSSPEdit"
                    nzType="default"
                    nz-button
                    class="test-link-button"
                    (click)="
                      onApiLinkTest(editSspService.formValue['apiLink'], $event)
                    "
                    [disabled]="editSspService.isDisabledTest"
                  >
                    Test
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group" *ngIf="editSspService.isShowImpTriggering">
              <label>Impression triggering</label>
              <nz-select
                nzPlaceHolder="Select Impression triggering"
                formControlName="imp_triggering"
                name="imp_triggering"
              >
                <nz-option
                  *ngFor="
                    let impTriggeringItem of editSspService.impTriggeringItems
                  "
                  [nzValue]="impTriggeringItem.id"
                  [nzLabel]="impTriggeringItem.name"
                ></nz-option>
              </nz-select>
            </div>
            <div class="form-group">
              <div class="prebid__row">
                <div class="prebid__input" name="platformStatsApi">
                  <label for="platformStatisticApiLinkSSPEdit"
                    >Platform Statistic API link</label
                  >
                  <textarea
                    id="platformStatisticApiLinkSSPEdit"
                    nz-input
                    class="form-control"
                    [disabled]="true"
                    name="endpoint"
                    formControlName="reportingApiLink"
                  ></textarea>
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="platformStatisticApiLinkCopySSPEdit"
                    nz-button
                    nzType="default"
                    type="button"
                    class="test-link-button"
                    (click)="onCopyLink($event, 'Copied Statistic API link')"
                    [cbContent]="editSspService.formValue['reportingApiLink']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="editSspService.isPrebidJsConnection()">
            <div
              class="form-group"
              *ngIf="editSspService.isShowPartnerNameForPrebidJS"
            >
              <div class="prebid__row">
                <div class="prebid__input">
                  <label for="partnerNamePrebidJsSSPEdit">Partner name</label>
                  <input
                    id="partnerNamePrebidJsSSPEdit"
                    nz-input
                    class="form-control"
                    [disabled]="true"
                    name="partnerName"
                    formControlName="partnerName"
                  />
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="partnerNameCopyPrebidJsSSPEdit"
                    nz-button
                    nzType="default"
                    type="button"
                    class="test-link-button"
                    (click)="onCopyLink($event, 'Copied Partner name')"
                    [cbContent]="editSspService.formValue['partnerName']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="prebid__row">
                <div class="prebid__input">
                  <label for="seatPreBidJsSSPEdit">Seat</label>
                  <input
                    id="seatPreBidJsSSPEdit"
                    nz-input
                    class="form-control"
                    [disabled]="true"
                    name="seatPreBid"
                    formControlName="seat"
                  />
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="seatCopyPrebidJsSSPEdit"
                    nz-button
                    nzType="default"
                    type="button"
                    class="test-link-button"
                    (click)="onCopyLink($event, 'Copied seat')"
                    [cbContent]="editSspService.formValue['seat']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="prebid__row">
                <div class="prebid__input">
                  <label for="tokenPreBidJsSSPEdit">Token</label>
                  <input
                    id="tokenPreBidJsSSPEdit"
                    nz-input
                    class="form-control"
                    [disabled]="true"
                    name="tokenPreBid"
                    formControlName="secretKey"
                  />
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="tokenCopyPrebidJsSSPEdit"
                    nz-button
                    nzType="default"
                    type="button"
                    class="test-link-button"
                    (click)="onCopyLink($event, 'Copied token')"
                    [cbContent]="editSspService.formValue['secretKey']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="prebid__row">
                <div class="prebid__input" name="platformStats">
                  <label for="sspStatisticApiLinkPrebidJsSSPEdit"
                    >SSP's Statistics API link</label
                  >
                  <input
                    id="sspStatisticApiLinkPrebidJsSSPEdit"
                    nz-input
                    type="text"
                    class="form-control"
                    name="sspApiUrl"
                    formControlName="apiLink"
                    (change)="
                      onValidateLink(
                        editSspService.formValue['apiLink'],
                        $event
                      )
                    "
                  />
                  <app-check-endpoint-status
                    [endpointValidationStatuses]="
                      editSspService.apiLinkValidationStatus
                    "
                    [apilink]="editSspService.apiLink"
                    [side]="'ssp'"
                    (hasError)="getError($event)"
                    [endpointId]="editSspService.formValue['id']"
                  ></app-check-endpoint-status>
                  <small class="replace"
                    >replace date with a placeholder [%Y-m-d%]</small
                  >
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="sspStatisticApiLinkTestPrebidJsSSPEdit"
                    nzType="default"
                    nz-button
                    class="test-link-button"
                    (click)="
                      onApiLinkTest(editSspService.formValue['apiLink'], $event)
                    "
                    [disabled]="editSspService.isDisabledTest"
                  >
                    Test
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group" *ngIf="editSspService.isShowImpTriggering">
              <label>Impression triggering</label>
              <nz-select
                nzPlaceHolder="Select Impression triggering"
                formControlName="imp_triggering"
                name="imp_triggering"
              >
                <nz-option
                  *ngFor="
                    let impTriggeringItem of editSspService.impTriggeringItems
                  "
                  [nzValue]="impTriggeringItem.id"
                  [nzLabel]="impTriggeringItem.name"
                ></nz-option>
              </nz-select>
            </div>
            <div class="form-group">
              <div class="prebid__row">
                <div class="prebid__input" name="platformStatsApi">
                  <label for="platformStatisticApiLinkPrebidJsSSPEdit"
                    >Platform Statistic API link</label
                  >
                  <textarea
                    id="platformStatisticApiLinkPrebidJsSSPEdit"
                    nz-input
                    class="form-control"
                    [disabled]="true"
                    name="endpoint"
                    formControlName="reportingApiLink"
                  ></textarea>
                </div>
                <div class="prebid__button">
                  <button
                    buttonLabel="platformStatisticApiLinkCopyPrebidJsSSPEdit"
                    nz-button
                    nzType="default"
                    type="button"
                    class="test-link-button"
                    (click)="onCopyLink($event, 'Copied Statistic API link')"
                    [cbContent]="editSspService.formValue['reportingApiLink']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="editSspService.tabIndex === 2">
          <div class="row" *ngIf="editSspService.hasScanner">
            <div class="col-6">
              <div class="form-title">
                Scanners
                <app-tooltip
                  [tooltipTitle]="
                    'Traffic scan services that will monitor traffic quality'
                  "
                ></app-tooltip>
              </div>
              <div
                class="form-group ch-new-line form-group_chb form-group_check"
                [class.isPixalatePrebid]="
                  editSspService.partnerSettings.usePixalatePrebid
                "
                id="scannersCheckboxes"
              >
                <div
                  class="check-tooltip-scanners"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection()
                  "
                >
                  <div class="checkbox" *ngIf="isTMTEnabled()">
                    <label
                      checkboxLabel="tmtSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      name="tmt"
                      formControlName="useTMT"
                      (ngModelChange)="onChangeChecked($event, 'useTMT')"
                      >TMT
                    </label>
                  </div>
                </div>
                <div class="check-tooltip-scanners">
                  <div
                    class="checkbox"
                    *ngIf="editSspService.partnerSettings.useGeoedge"
                  >
                    <label
                      checkboxLabel="useGeoedgeSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      name="geoedge"
                      formControlName="useGeoedge"
                      (ngModelChange)="onChangeChecked($event, 'useGeoedge')"
                      >Geoedge
                    </label>
                  </div>
                </div>
                <div
                  class="check-tooltip-scanners check-tooltip-scanners--key"
                  *ngIf="editSspService.partnerSettings.useGeoedge"
                >
                  <div
                    class="checkbox"
                    *ngIf="editSspService.formValue.useGeoedge"
                  >
                    <input
                      id="geoedgeKeySSPRtbPrebidHasScannersEdit"
                      nz-input
                      class="form-control"
                      name="geoedge_key"
                      type="text"
                      placeholder="Enter the custom key"
                      formControlName="geoedge_key"
                      (ngModelChange)="onChangeChecked($event, 'geoedge_key')"
                    />
                  </div>
                </div>
                <div class="check-tooltip-scanners">
                  <div class="checkbox" *ngIf="isBotmanPostBidIsEnabled()">
                    <label
                      checkboxLabel="botmanPostBidSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      name="botman_enable_postbid"
                      formControlName="botman_enable_postbid"
                      (ngModelChange)="
                        onChangeChecked($event, 'enable_postbid')
                      "
                      >Botman (Post-bid)
                    </label>
                  </div>
                </div>
                <div class="check-tooltip-scanners">
                  <div class="checkbox" *ngIf="isBotmanPreBidIsEnabled()">
                    <label
                      checkboxLabel="botmanPreBidSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      name="botman_enable_prebid"
                      formControlName="botman_enable_prebid"
                      (ngModelChange)="onChangeChecked($event, 'enable_prebid')"
                      >Botman (Pre-bid)
                    </label>
                  </div>
                </div>

                <div
                  class="check-tooltip-scanners"
                  *ngIf="isMediaGuardEnabled()"
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="humanMediaGuardPreBidSSP"
                      nz-checkbox
                      formControlName="media_guard_enable_prebid"
                      name="media_guard_enable_prebid"
                      media_guard_percent
                      >Human MediaGuard (Pre-bid)</label
                    >
                  </div>
                </div>
                <div
                  class="input-group"
                  *ngIf="editSspService.formValue.media_guard_enable_prebid"
                >
                  <label>Human MediaGuard Scan Ratio</label>
                  <input
                    nz-input
                    type="number"
                    width="10"
                    id="pixalateIFAIVTPercentSSP"
                    name="media_guard_percent"
                    formControlName="media_guard_percent"
                    class="form-control"
                    min="1"
                    max="100"
                  />
                </div>

                <div
                  class="check-tooltip-scanners"
                  *ngIf="isFraudSensorEnabled()"
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="humanFraudsensorPostBidSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="fraud_sensor_enable_postbid"
                      name="fraud_sensor_enable_postbid"
                      >Human FraudSensor (Post-bid)</label
                    >
                  </div>
                </div>

                <div
                  class="check-tooltip-scanners"
                  *ngIf="isFraudLogixEnabled()"
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="fraudLogixPostBidDSP"
                      nz-checkbox
                      formControlName="fraud_logix_enable_postbid"
                      name="fraud_logix_enable_postbid"
                    >
                      Fraudlogix (Post-bid)
                    </label>
                  </div>
                </div>

                <div
                  class="check-tooltip-scanners"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection()
                  "
                >
                  <div
                    class="checkbox"
                    *ngIf="editSspService.partnerSettings.usePM"
                  >
                    <label
                      checkboxLabel="usePMSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      name="p-media"
                      (ngModelChange)="onChangeChecked($event, 'usePMKey')"
                      formControlName="usePMKey"
                    >
                      Protected Media (Post-bid)
                    </label>
                  </div>
                </div>
                <div
                  class="check-tooltip-scanners"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection()
                  "
                >
                  <div
                    class="checkbox"
                    *ngIf="editSspService.partnerSettings.usePixalate"
                  >
                    <label
                      checkboxLabel="usePixalateSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="is_pixalate_postbid"
                      (ngModelChange)="
                        onChangeChecked($event, 'is_pixalate_postbid')
                      "
                      name="is_pixalate_postbid"
                      >Pixalate (Post-bid)</label
                    >
                  </div>
                </div>
                <div
                  class="check-tooltip-scanners"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection()
                  "
                >
                  <div
                    class="checkbox"
                    *ngIf="editSspService.partnerSettings.usePMPreBid"
                  >
                    <div class="protected-media-block">
                      <div class="check-tooltip">
                        <label
                          checkboxLabel="usePMPrebidSSPRtbPrebidHasScannersEdit"
                          nz-checkbox
                          formControlName="usePMPrebid"
                          (ngModelChange)="
                            onChangeChecked($event, 'usePMPrebid')
                          "
                          name="pre-bid"
                          >Protected Media (Pre-bid)
                        </label>
                        <app-tooltip
                          [tooltipTitle]="
                            'Use Protected Media Pre-bid for scanning. If you don\'t want to use it for this endpoint, select the quality of traffic on this endpoint'
                          "
                        ></app-tooltip>
                      </div>
                      <div
                        class="select-tooltip"
                        *ngIf="!editSspService.formValue.usePMPrebid"
                      >
                        <nz-select
                          nzShowSearch
                          nzPlaceHolder
                          formControlName="pmIsFraud"
                          name="pmIsFraud"
                        >
                          <nz-option
                            *ngFor="let item of editSspService.fraudItems"
                            [nzValue]="item.id"
                            [nzLabel]="item.name"
                          ></nz-option>
                        </nz-select>
                        <app-tooltip
                          [tooltipTitle]="
                            'Clean traffic - we will consider traffic from this endpoint as high-quality and send it to all DSPs\nFraud traffic - we will consider traffic from this endpoint as low-quality and send it just to DSPs with valid fraud of 100%'
                          "
                        ></app-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="pixalate-block"
                *ngIf="editSspService.partnerSettings.usePixalatePrebid"
                formGroupName="pixalate_pb_settings"
                customLabel="pixalatePrebidBlockSSPRtbPrebidHasScannersEdit"
              >
                <div
                  *ngIf="editSspService.partnerSettings.pixalate_pb_settings.ip"
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidIpSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="ip"
                      name="pixalate_pb_settings.ip"
                      >Pixalate Pre-bid IP filter</label
                    >
                  </div>
                  <div
                    class="input-group"
                    *ngIf="editSspService.formValue.pixalate_pb_settings.ip"
                  >
                    <label>Pixalate IP IVT Percent</label>
                    <input
                      id="pixalateIpPercentSSPRtbPrebidHasScannersEdit"
                      nz-input
                      type="number"
                      width="10"
                      name="pixalate_pb_settings.ip_percent"
                      formControlName="ip_percent"
                      (keyup)="onPreventInput($event, 'ip_percent')"
                      (click)="onPreventInput($event, 'ip_percent')"
                      class="form-control"
                    />
                  </div>
                </div>
                <div
                  *ngIf="
                    editSspService.partnerSettings.pixalate_pb_settings.ifa
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidIfaSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="ifa"
                      name="pixalate_pb_settings.ifa"
                      >Pixalate Pre-bid IFA filter</label
                    >
                  </div>
                  <div
                    class="input-group"
                    *ngIf="editSspService.formValue.pixalate_pb_settings.ifa"
                  >
                    <label>Pixalate IFA IVT Percent</label>
                    <input
                      id="pixalateIfaPercentSSPRtbPrebidHasScannersEdit"
                      nz-input
                      type="number"
                      width="10"
                      name="pixalate_pb_settings.ifa_percent"
                      formControlName="ifa_percent"
                      (keyup)="onPreventInput($event, 'ifa_percent')"
                      (click)="onPreventInput($event, 'ifa_percent')"
                      class="form-control"
                    />
                  </div>
                </div>
                <div
                  *ngIf="editSspService.partnerSettings.pixalate_pb_settings.ua"
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidUaSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="ua"
                      name="pixalate_pb_settings.ua"
                      >Pixalate Pre-bid UA filter</label
                    >
                  </div>
                </div>
                <div
                  *ngIf="
                    editSspService.partnerSettings.pixalate_pb_settings.ott
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidOttSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="ott"
                      name="pixalate_pb_settings.ott"
                      >Pixalate Pre-bid OTT filter</label
                    >
                  </div>
                  <div
                    class="input-group"
                    *ngIf="editSspService.formValue.pixalate_pb_settings.ott"
                  >
                    <label>Pixalate OTT IVT Percent</label>
                    <input
                      id="pixalateOttPercentSSPRtbPrebidHasScannersEdit"
                      nz-input
                      type="number"
                      width="10"
                      name="pixalate_pb_settings.ott_percent"
                      formControlName="ott_percent"
                      (keyup)="onPreventInput($event, 'ott_percent')"
                      (click)="onPreventInput($event, 'ott_percent')"
                      class="form-control"
                    />
                  </div>
                </div>
                <div
                  *ngIf="
                    editSspService.partnerSettings.pixalate_pb_settings.def_app
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidDefAppSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="def_app"
                      name="pixalate_pb_settings.def_app"
                      >Pixalate Pre-bid Defased App filter</label
                    >
                  </div>
                </div>
                <div
                  *ngIf="
                    editSspService.partnerSettings.pixalate_pb_settings.domain
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidDomainSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="domain"
                      name="pixalate_pb_settings.domain"
                      >Pixalate Pre-bid Domain filter</label
                    >
                  </div>
                </div>
                <div
                  *ngIf="
                    editSspService.partnerSettings.pixalate_pb_settings.hr_app
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidHrAppSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="hr_app"
                      name="pixalate_pb_settings.hr_app"
                      >Pixalate Pre-bid Bundle filter</label
                    >
                  </div>
                  <div
                    class="input-group"
                    *ngIf="editSspService.formValue.pixalate_pb_settings.hr_app"
                  >
                    <label>Pixalate Bundle IVT Percent</label>
                    <input
                      id="pixalateHrAppPercentSSPRtbPrebidHasScannersEdit"
                      nz-input
                      type="number"
                      width="10"
                      name="pixalate_pb_settings.hr_app_percent"
                      formControlName="hr_app_percent"
                      (keyup)="onPreventInput($event, 'hr_app_percent')"
                      (click)="onPreventInput($event, 'hr_app_percent')"
                      class="form-control"
                    />
                  </div>
                </div>
                <div
                  *ngIf="
                    editSspService.partnerSettings.pixalate_pb_settings
                      .dc_subnet
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidDcSubnetSSPRtbPrebidHasScannersEdit"
                      nz-checkbox
                      formControlName="dc_subnet"
                      name="pixalate_pb_settings.dc_subnet"
                      >Pixalate Pre-bid Data Center IP filter</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-title">Filters</div>
              <div class="form-group">
                <div class="row b-row">
                  <div class="col-12">
                    <label class="label-title"
                      >DSPs
                      <app-tooltip
                        [tooltipTitle]="
                          'Choose allowed/blocked DSPs for this endpoint'
                        "
                      ></app-tooltip>
                    </label>
                  </div>
                  <div class="col-4">
                    <nz-select
                      [class.allowed-filter]="
                        editSspService.formValue.allowedDspListTrigger === 1
                      "
                      [class.blocked-filter]="
                        editSspService.formValue.allowedDspListTrigger === 0
                      "
                      formControlName="allowedDspListTrigger"
                      name="allowedDspListTrigger"
                    >
                      <nz-option
                        *ngFor="
                          let trigger of editSspService.allowCountriesTrigger
                        "
                        [nzValue]="trigger.id"
                        [nzLabel]="trigger.name"
                      ></nz-option>
                    </nz-select>
                  </div>
                  <div class="col-8">
                    <nz-tree-select
                      name="dspList"
                      nzPlaceHolder="Select DSP Endpoint(s)"
                      nzPlacement="bottomRight"
                      [nzDropdownStyle]="{ width: '300px' }"
                      [class.allowed-filter]="
                        editSspService.formValue['allowedDspListTrigger'] === 1
                      "
                      [class.blocked-filter]="
                        editSspService.formValue['allowedDspListTrigger'] === 0
                      "
                      formControlName="dspList"
                      [nzMaxTagCount]="3"
                      [nzMaxTagPlaceholder]="omittedPlaceHolder"
                      [nzNodes]="editSspService.companiesDSPDropdown"
                      [nzAllowClear]="false"
                      [nzShowSearch]="true"
                      [nzMultiple]="true"
                      nzVirtualHeight="250px"
                      nzCheckable
                      [nzTreeTemplate]="customTpl"
                      [nzHideUnMatched]="true"
                    ></nz-tree-select>
                    <ng-template #omittedPlaceHolder let-omittedValues
                      >and {{ omittedValues.length }} more...</ng-template
                    >
                    <ng-template #customTpl let-item>
                      {{ item.title | trunc: [20] }}
                    </ng-template>
                  </div>
                </div>
              </div>
              <div
                class="form-group"
                *ngIf="editSspService.filterLists.length > 0"
              >
                <label>Filter Lists</label>
                <nz-select
                  nzMode="multiple"
                  formControlName="filter_list_ids"
                  nzPlaceHolder="Select Filter List(s)"
                  nzShowSearch
                  [nzShowArrow]="true"
                  name="filter_list_ids"
                  [nzMaxTagCount]="10"
                >
                  <nz-option-group
                    *ngFor="let itemGroup of editSspService.filterLists"
                    [nzLabel]="itemGroup.item_group"
                  >
                    <nz-option
                      *ngFor="let item of itemGroup.items"
                      [nzValue]="item.id"
                      [nzLabel]="item.name + ': ' + item.count + ' item(s)'"
                      [nzDisabled]="!!item.is_all_ssp"
                    ></nz-option>
                  </nz-option-group>
                </nz-select>
              </div>
              <div class="row b-row" *ngIf="editSspService.isJSConnection()">
                <div class="col-12">
                  <div class="form-group" formGroupName="js">
                    <label>IAB Categories</label>
                    <nz-select
                      nzShowSearch
                      nzPlaceHolder="Select Categories"
                      formControlName="categories"
                      name="categories"
                      [nzShowArrow]="true"
                      nzMode="multiple"
                    >
                      <nz-option
                        *ngFor="let category of editSspService.categories"
                        [nzValue]="category.id"
                        [nzLabel]="category.name"
                      >
                      </nz-option>
                    </nz-select>
                  </div>
                </div>
              </div>
              <div
                class="form-group"
                *ngIf="
                  (editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection() ||
                    editSspService.isPrebidJsConnection()) &&
                  editSspService.formValue.useBcatFilter
                "
              >
                <div class="checkbox">
                  <label>Custom BCAT filter</label>
                  <nz-tree-select
                    name="iab_bcat"
                    nzPlaceHolder="Select IAB Categories"
                    formControlName="iab_bcat"
                    [nzMaxTagCount]="3"
                    [nzMaxTagPlaceholder]="omittedPlaceHolder"
                    [nzNodes]="editSspService.blockedIabCategories"
                    [nzAllowClear]="false"
                    [nzShowSearch]="true"
                    [nzMultiple]="true"
                    nzVirtualHeight="250px"
                    nzCheckable
                  ></nz-tree-select>
                  <ng-template #omittedPlaceHolder let-omittedValues
                    >and {{ omittedValues.length }} more...</ng-template
                  >
                </div>
              </div>
              <div
                class="form-group ch-new-line form-group_chb form-group_check"
                id="filtersCheckboxes"
              >
                <div
                  class="checkbox"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection() ||
                    editSspService.isPrebidJsConnection()
                  "
                >
                  <label
                    checkboxLabel="bcatFilterSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="useBcatFilter"
                    name="useBcatFilter"
                    (ngModelChange)="onChangeBCATCheckboxState($event)"
                    >Bcat filter</label
                  >
                </div>
                <div
                  class="checkbox"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection() ||
                    editSspService.isPrebidJsConnection()
                  "
                >
                  <label
                    checkboxLabel="badvFilterSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="has_badv_filter"
                    (ngModelChange)="onChangeChecked($event, 'has_badv_filter')"
                    name="hasBadvFilter"
                    >Badv filter</label
                  >
                </div>
                <div
                  class="check-tooltip"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection() ||
                    editSspService.isPrebidJsConnection()
                  "
                >
                  <label
                    checkboxLabel="filterOutDspResponsesWithoutIurlSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="is_iurl_filter"
                    name="is_iurl_filter"
                  >
                    Filter out DSP responses without iURL
                  </label>

                  <app-tooltip
                    tooltipTitle="Activating “Filter out DSP responses without iURL” checkbox will initiate checking DSP responses for iURL presence.
                    If iURL is not present in the DSP response, it will be dropped"
                  ></app-tooltip>
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="responseWithAdomainSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="has_response_adomain"
                    (ngModelChange)="
                      onChangeChecked($event, 'has_response_adomain')
                    "
                    name="has_response_adomain"
                    >Responses with adomain</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="secureLinksOnlySSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="use_secure_filter"
                    name="use_secure_filter"
                  >
                    Secure links only
                    <app-tooltip
                      [tooltipTitle]="
                        'if the response from DSP contains at least one insecure link (http format) - such response will be dropped for this EP'
                      "
                    ></app-tooltip>
                  </label>
                </div>
                <div class="checkbox">
                  <label
                    nz-checkbox
                    formControlName="is_origin_device_object"
                    name="is_origin_device_object"
                  >
                    Original device object
                    <app-tooltip
                      tooltipTitle="When enabled, the original “device type” value from the request will be passed to the DSP.
                  If it's missing, the system will attempt to detect the device type using the User-Agent.
                  If both are unavailable, the request will be dropped."
                    ></app-tooltip>
                  </label>
                </div>
                <div class="check-tooltip">
                  <label
                    nz-checkbox
                    formControlName="is_default_coppa"
                    name="is_default_coppa"
                  >
                    Default COPPA
                    <app-tooltip
                      tooltipTitle="When enabled, the system will automatically insert coppa=0 into bid requests if the original request does not include the COPPA attribute.
                      This logic applies only to requests with the USA geo."
                    ></app-tooltip>
                  </label>
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="originDeviceObjectSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="use_geo_from_ip"
                    name="use_geo_from_ip"
                  >
                    Prioritize GEO from IP
                    <app-tooltip
                      tooltipTitle="When enabled, the system will attempt to determine GEO based on the user’s IP address.
                    If unsuccessful, the GEO from the original SSP request will be used. If neither is available, the GEO field will be passed empty to the DSP.
                    Note: This setting affects only the GEO field and operates independently from the “Original Device Object” checkbox.
                    If both checkboxes are enabled, the system will still prioritize IP-based GEO detection."
                    ></app-tooltip>
                  </label>
                </div>
              </div>

              <hr />

              <div class="form-title form-title--additional">
                Additional Settings
              </div>
              <div
                class="form-group ch-new-line form-group_chb form-group_check"
                id="additional"
              >
                <div
                  class="checkbox"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection()
                  "
                >
                  <label
                    checkboxLabel="sendGzipResponsesSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="gzipResponses"
                    name="gzipResponses"
                  >
                    Send gzip responses
                  </label>
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="sendTestResponsesSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="isForTest"
                    name="isForTest"
                  >
                    Send test responses
                  </label>
                </div>
                <div
                  class="check-tooltip"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection()
                  "
                >
                  <label
                    checkboxLabel="gppSupportSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="is_gpp_support"
                    name="is_gpp_support"
                    >GPP support</label
                  >
                  <app-tooltip
                    [tooltipTitle]="
                      'Activating the GPP support checkbox ensures that regulations specified for GPP are verified and applied to all incoming requests at this endpoint'
                    "
                  ></app-tooltip>
                </div>
                <div
                  class="checkbox"
                  *ngIf="editSspService.isShowDemandBooster"
                >
                  <label
                    checkboxLabel="demandBoosterSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      editSspService.restrictionTooltipMessage('Demand Booster')
                    "
                    nzTooltipPlacement="top"
                    formControlName="has_demand_booster"
                    name="has_demand_booster"
                  >
                    Demand Booster
                  </label>
                </div>
                <div class="check-tooltip">
                  <label
                    checkboxLabel="maximisedBidpriceSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      editSspService.restrictionTooltipMessage(
                        'Maximised bid price'
                      )
                    "
                    nzTooltipPlacement="top"
                    formControlName="has_maximised_bidprice"
                    name="has_maximised_bidprice"
                  >
                    Maximised bid price
                  </label>
                  <app-tooltip
                    tooltipTitle="Maximised Bidprice auction is available for SSP and DSP connections using fixed margins.
                  This feature will increase the bidprice sent to the SSP.
                  When calculating payouts, only the DSP’s markup is deducted from the bid price, and the SSP’s markup will be ignored.
                  This feature increases your chances of winning the auction on the SSP side.
                  Profits are then calculated solely on the fixed markup set by the DSP."
                  ></app-tooltip>
                </div>
                <div
                  class="check-tooltip"
                  *ngIf="editSspService.isPrebidJsConnection()"
                >
                  <label
                    checkboxLabel="gppSupportSSPRtbPrebidHasScannersEdit"
                    nz-checkbox
                    formControlName="is_gpp_support"
                    name="is_gpp_support"
                  >
                    GPP support
                  </label>
                  <app-tooltip
                    [tooltipTitle]="
                      'Activating the GPP support checkbox ensures that regulations specified for GPP are verified and applied to all incoming requests at this endpoint'
                    "
                  ></app-tooltip>
                </div>
                <div
                  class="pub-group"
                  *ngIf="
                    editSspService.isRTBConnection() ||
                    editSspService.isPreBidConnection()
                  "
                >
                  <label class="label-title">
                    Writing publisher IDs

                    <app-tooltip
                      tooltipTitle="This setting will help you manage writing publisher IDs per requests and responses in the statistics.
                    If the supply partner will send you auto-generated publisher IDs, which may be unique per each request, this will lead to issues with statistics load.
                    The automated option is selected by default.
                    Logic: If daily statistics per particular SSP connection reach 100 000 values of unique publisher id's
                    the platform will automatically stop recording requests and response statistics per publisher ids.
                    You may enable/disable writing publisher IDs per particular SSP connection inside the statistics at your sole discretion."
                    ></app-tooltip>
                  </label>
                  <nz-select
                    nzShowSearch
                    nzPlaceHolder="Select Writing Publisher IDs"
                    formControlName="writing_pub_ids"
                    name="writing_pub_ids"
                  >
                    <nz-option
                      *ngFor="let item of editSspService.pubWritingItems"
                      [nzValue]="item.id"
                      [nzLabel]="item.name"
                    ></nz-option>
                  </nz-select>
                </div>

                <div class="check-tooltip">
                  <label
                    nz-checkbox
                    formControlName="has_new_iab_categories"
                    name="has_new_iab_categories"
                    (ngModelChange)="
                      editSspService.onChangeIABCategoriesCheckboxStateHandler(
                        $event
                      )
                    "
                    >IAB Categories</label
                  >
                </div>

                <div
                  class="form-group"
                  *ngIf="editSspService.formValue.has_new_iab_categories"
                >
                  <div class="checkbox">
                    <label>
                      IAB Categories
                      <app-tooltip
                        tooltipTitle="Choose the IAB Categories that represent your supply"
                      ></app-tooltip>
                    </label>
                    <nz-tree-select
                      name="iab_cat"
                      nzPlaceHolder="Select IAB Categories"
                      formControlName="iab_cat"
                      [nzMaxTagCount]="3"
                      [nzMaxTagPlaceholder]="omittedPlaceHolder"
                      [nzNodes]="editSspService.iabCategories"
                      [nzAllowClear]="false"
                      [nzShowSearch]="true"
                      [nzMultiple]="true"
                      nzVirtualHeight="250px"
                      nzCheckable
                    ></nz-tree-select>
                    <ng-template #omittedPlaceHolder let-omittedValues
                      >and {{ omittedValues.length }} more...</ng-template
                    >
                  </div>
                </div>

                <div class="check-tooltip">
                  <label
                    nz-checkbox
                    formControlName="is_flexible_size_matching"
                    name="is_flexible_size_matching"
                    >Flexible size matching</label
                  >
                  <app-tooltip
                    tooltipTitle="Enables processing of bid responses with creatives that are smaller than or equal to the bid request size dimensions."
                  ></app-tooltip>
                </div>

                <div class="check-tooltip">
                  <label
                    nz-checkbox
                    formControlName="is_multi_ad_response"
                    name="is_multi_ad_response"
                    >Multi-bid response logic</label
                  >
                  <app-tooltip
                    tooltipTitle="When enabled, Multi-bid response logic will activate on the SSP endpoint, allowing multiple creatives/bids to be returned in a single SSP response instead of only one winning creative."
                  ></app-tooltip>
                </div>

                <div
                  class="form-group"
                  *ngIf="editSspService.formValue.is_multi_ad_response"
                >
                  <label for="endpointSSPMultiAdResponsesEdit"
                    >Maximum Bids per response
                    <app-tooltip
                      tooltipTitle="Defines the maximum number of bids allowed in a single response. Allowed values: from 2 to 10"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    type="number"
                    id="endpointSSPMultiAdResponsesEdit"
                    name="multi_ad_responses"
                    formControlName="multi_ad_responses"
                    class="form-control"
                    min="2"
                    max="10"
                  />
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!editSspService.hasScanner">
            <div class="row">
              <div class="col-6">
                <div class="form-title form-title--filters">Filters</div>
                <div class="form-group">
                  <div class="row b-row">
                    <div class="col-12">
                      <label class="label-title"
                        >DSPs
                        <app-tooltip
                          [tooltipTitle]="
                            'Choose allowed/blocked DSPs for this endpoint'
                          "
                        ></app-tooltip>
                      </label>
                    </div>
                    <div class="col-4">
                      <nz-select
                        [class.allowed-filter]="
                          editSspService.formValue.allowedDspListTrigger === 1
                        "
                        [class.blocked-filter]="
                          editSspService.formValue.allowedDspListTrigger === 0
                        "
                        formControlName="allowedDspListTrigger"
                        name="allowedDspListTrigger"
                      >
                        <nz-option
                          *ngFor="
                            let trigger of editSspService.allowCountriesTrigger
                          "
                          [nzValue]="trigger.id"
                          [nzLabel]="trigger.name"
                        ></nz-option>
                      </nz-select>
                    </div>
                    <div class="col-8">
                      <nz-tree-select
                        name="dspList"
                        nzPlaceHolder="Select DSP Endpoint(s)"
                        nzPlacement="bottomRight"
                        [nzDropdownStyle]="{ width: '300px' }"
                        [class.allowed-filter]="
                          editSspService.formValue['allowedDspListTrigger'] ===
                          1
                        "
                        [class.blocked-filter]="
                          editSspService.formValue['allowedDspListTrigger'] ===
                          0
                        "
                        formControlName="dspList"
                        [nzMaxTagCount]="3"
                        [nzMaxTagPlaceholder]="omittedPlaceHolder"
                        [nzNodes]="editSspService.companiesDSPDropdown"
                        [nzAllowClear]="false"
                        [nzShowSearch]="true"
                        [nzMultiple]="true"
                        nzVirtualHeight="250px"
                        nzCheckable
                        [nzTreeTemplate]="customTpl"
                        [nzHideUnMatched]="true"
                      ></nz-tree-select>
                      <ng-template #omittedPlaceHolder let-omittedValues
                        >and {{ omittedValues.length }} more...</ng-template
                      >
                      <ng-template #customTpl let-item>
                        {{ item.title | trunc: [20] }}
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div
                  class="form-group"
                  *ngIf="editSspService.filterLists.length > 0"
                >
                  <label>Filter Lists</label>
                  <nz-select
                    nzMode="multiple"
                    formControlName="filter_list_ids"
                    nzPlaceHolder="Select Filter List(s)"
                    nzShowSearch
                    [nzShowArrow]="true"
                    name="filter_list_ids"
                    [nzMaxTagCount]="10"
                  >
                    <nz-option-group
                      *ngFor="let itemGroup of editSspService.filterLists"
                      [nzLabel]="itemGroup.item_group"
                    >
                      <nz-option
                        *ngFor="let item of itemGroup.items"
                        [nzValue]="item.id"
                        [nzLabel]="item.name + ': ' + item.count + ' item(s)'"
                        [nzDisabled]="!!item.is_all_ssp"
                      ></nz-option>
                    </nz-option-group>
                  </nz-select>
                </div>
                <div class="row b-row" *ngIf="editSspService.isJSConnection()">
                  <div class="col-12">
                    <div class="form-group" formGroupName="js">
                      <label>IAB Categories</label>
                      <nz-select
                        nzShowSearch
                        nzPlaceHolder="Select Categories"
                        formControlName="categories"
                        name="categories"
                        [nzShowArrow]="true"
                        nzMode="multiple"
                      >
                        <nz-option
                          *ngFor="let category of editSspService.categories"
                          [nzValue]="category.id"
                          [nzLabel]="category.name"
                        >
                        </nz-option>
                      </nz-select>
                    </div>
                  </div>
                </div>
                <div
                  class="form-group"
                  *ngIf="
                    (editSspService.isRTBConnection() ||
                      editSspService.isPreBidConnection() ||
                      editSspService.isPrebidJsConnection()) &&
                    editSspService.formValue.useBcatFilter
                  "
                >
                  <div class="checkbox">
                    <label>Custom BCAT filter</label>
                    <nz-tree-select
                      name="iab_bcat"
                      nzPlaceHolder="Select IAB Categories"
                      formControlName="iab_bcat"
                      [nzMaxTagCount]="3"
                      [nzMaxTagPlaceholder]="omittedPlaceHolder"
                      [nzNodes]="editSspService.blockedIabCategories"
                      [nzAllowClear]="false"
                      [nzShowSearch]="true"
                      [nzMultiple]="true"
                      nzVirtualHeight="250px"
                      nzCheckable
                    ></nz-tree-select>
                    <ng-template #omittedPlaceHolder let-omittedValues
                      >and {{ omittedValues.length }} more...</ng-template
                    >
                  </div>
                </div>
                <div
                  class="form-group ch-new-line form-group_chb form-group_check"
                  id="filtersCheckboxes"
                >
                  <div
                    class="checkbox"
                    *ngIf="
                      editSspService.isRTBConnection() ||
                      editSspService.isPreBidConnection() ||
                      editSspService.isPrebidJsConnection()
                    "
                  >
                    <label
                      checkboxLabel="bcatFilterWithoutScannersEdit"
                      nz-checkbox
                      formControlName="useBcatFilter"
                      name="useBcatFilter"
                      (ngModelChange)="onChangeBCATCheckboxState($event)"
                    >
                      Bcat filter
                    </label>
                  </div>
                  <div
                    class="checkbox"
                    *ngIf="
                      editSspService.isRTBConnection() ||
                      editSspService.isPreBidConnection() ||
                      editSspService.isPrebidJsConnection()
                    "
                  >
                    <label
                      checkboxLabel="badvFilterWithoutScannersEdit"
                      nz-checkbox
                      formControlName="has_badv_filter"
                      name="hasBadvFilter"
                    >
                      Badv filter
                    </label>
                  </div>
                  <div
                    class="check-tooltip"
                    *ngIf="
                      editSspService.isRTBConnection() ||
                      editSspService.isPreBidConnection() ||
                      editSspService.isPrebidJsConnection()
                    "
                  >
                    <label
                      checkboxLabel="filterOutDspResponsesWithoutIurlWithoutScannersEdit"
                      nz-checkbox
                      formControlName="is_iurl_filter"
                      name="is_iurl_filter"
                    >
                      Filter out DSP responses without iURL
                    </label>
                    <app-tooltip
                      tooltipTitle="Activating “Filter out DSP responses without iURL” checkbox will initiate checking DSP responses for iURL presence.
                    If iURL is not present in the DSP response, it will be dropped"
                    ></app-tooltip>
                  </div>
                  <div class="checkbox">
                    <label
                      checkboxLabel="responseWithAdomainWithoutScannersEdit"
                      nz-checkbox
                      formControlName="has_response_adomain"
                      name="has_response_adomain"
                    >
                      Responses with adomain
                    </label>
                  </div>
                  <div class="check-tooltip">
                    <label
                      checkboxLabel="secureLinksOnlyWithoutScannersEdit"
                      nz-checkbox
                      formControlName="use_secure_filter"
                      name="use_secure_filter"
                    >
                      Secure links only
                    </label>
                    <app-tooltip
                      [tooltipTitle]="
                        'if the response from DSP contains at least one insecure link (http format) - such response will be dropped for this EP'
                      "
                    ></app-tooltip>
                  </div>
                  <div class="checkbox">
                    <label
                      nz-checkbox
                      formControlName="is_origin_device_object"
                      name="is_origin_device_object"
                    >
                      Original device object
                      <app-tooltip
                        tooltipTitle="When enabled, the original “device type” value from the request will be passed to the DSP.
                        If it's missing, the system will attempt to detect the device type using the User-Agent.
                        If both are unavailable, the request will be dropped."
                      ></app-tooltip>
                    </label>
                  </div>
                  <div class="check-tooltip">
                    <label
                      nz-checkbox
                      formControlName="is_default_coppa"
                      name="is_default_coppa"
                    >
                      Default COPPA
                      <app-tooltip
                        tooltipTitle="When enabled, the system will automatically insert coppa=0 into bid requests if the original request does not include the COPPA attribute.
                        This logic applies only to requests with the USA geo."
                      ></app-tooltip>
                    </label>
                  </div>
                  <div class="checkbox">
                    <label
                      checkboxLabel="originDeviceObjectWithoutScannersEdit"
                      nz-checkbox
                      formControlName="use_geo_from_ip"
                      name="use_geo_from_ip"
                    >
                      Prioritize GEO from IP
                      <app-tooltip
                        tooltipTitle="When enabled, the system will attempt to determine GEO based on the user’s IP address.
                      If unsuccessful, the GEO from the original SSP request will be used. If neither is available, the GEO field will be passed empty to the DSP.
                      Note: This setting affects only the GEO field and operates independently from the “Original Device Object” checkbox.
                      If both checkboxes are enabled, the system will still prioritize IP-based GEO detection."
                      ></app-tooltip>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-title form-title--additional">
                  Additional Settings
                </div>
                <div
                  class="form-group ch-new-line form-group_chb form-group_check"
                  id="additional"
                >
                  <div
                    class="checkbox"
                    *ngIf="
                      editSspService.isRTBConnection() ||
                      editSspService.isPreBidConnection()
                    "
                  >
                    <label
                      checkboxLabel="sendGzipResponsesWithoutScannersEdit"
                      nz-checkbox
                      formControlName="gzipResponses"
                      name="gzipResponses"
                    >
                      Send gzip responses
                    </label>
                  </div>
                  <div class="checkbox">
                    <label
                      checkboxLabel="sendTestResponsesWithoutScannersEdit"
                      nz-checkbox
                      formControlName="isForTest"
                      name="isForTest"
                    >
                      Send test responses
                    </label>
                  </div>
                  <div
                    class="check-tooltip"
                    *ngIf="
                      editSspService.isRTBConnection() ||
                      editSspService.isPreBidConnection()
                    "
                  >
                    <label
                      checkboxLabel="gppSupportWithoutScannersEdit"
                      nz-checkbox
                      formControlName="is_gpp_support"
                      name="is_gpp_support"
                    >
                      GPP support
                    </label>
                    <app-tooltip
                      [tooltipTitle]="
                        'Activating the GPP support checkbox ensures that regulations specified for GPP are verified and applied to all incoming requests at this endpoint'
                      "
                    ></app-tooltip>
                  </div>
                  <div
                    class="checkbox"
                    *ngIf="editSspService.isShowDemandBooster"
                  >
                    <label
                      checkboxLabel="demandBoosterWithoutScannersEdit"
                      nz-checkbox
                      formControlName="has_demand_booster"
                      name="has_demand_booster"
                      nz-tooltip
                      nzTooltipOverlayClassName="item-tooltip"
                      [nzTooltipTitle]="
                        editSspService.restrictionTooltipMessage(
                          'Demand Booster'
                        )
                      "
                      nzTooltipPlacement="top"
                    >
                      Demand Booster
                    </label>
                  </div>
                  <div class="check-tooltip">
                    <label
                      checkboxLabel="maximisedBidpriceWithoutScannersEdit"
                      nz-checkbox
                      formControlName="has_maximised_bidprice"
                      name="has_maximised_bidprice"
                      nz-tooltip
                      nzTooltipOverlayClassName="item-tooltip"
                      [nzTooltipTitle]="
                        editSspService.restrictionTooltipMessage(
                          'Maximised bid price'
                        )
                      "
                    >
                      Maximised bid price
                    </label>
                    <app-tooltip
                      tooltipTitle="Maximised Bidprice auction is available for SSP and DSP connections using fixed margins.
              This feature will increase the bidprice sent to the SSP.
              When calculating payouts, only the DSP’s markup is deducted from the bid price, and the SSP’s markup will be ignored.
              This feature increases your chances of winning the auction on the SSP side.
              Profits are then calculated solely on the fixed markup set by the DSP."
                    ></app-tooltip>
                  </div>
                  <div
                    class="check-tooltip"
                    *ngIf="editSspService.isPrebidJsConnection()"
                  >
                    <label
                      checkboxLabel="gppSupportPrebidJsWithoutScannersEdit"
                      nz-checkbox
                      formControlName="is_gpp_support"
                      name="is_gpp_support"
                    >
                      GPP support
                    </label>
                    <app-tooltip
                      [tooltipTitle]="
                        'Activating the GPP support checkbox ensures that regulations specified for GPP are verified and applied to all incoming requests at this endpoint'
                      "
                    ></app-tooltip>
                  </div>
                  <div
                    class="pub-group"
                    *ngIf="
                      editSspService.isRTBConnection() ||
                      editSspService.isPreBidConnection()
                    "
                  >
                    <label class="label-title">
                      Writing publisher IDs

                      <app-tooltip
                        tooltipTitle="This setting will help you manage writing publisher IDs per requests and responses in the statistics.
                      If the supply partner will send you auto-generated publisher IDs, which may be unique per each request, this will lead to issues with statistics load.
                      The automated option is selected by default.
                      Logic: If daily statistics per particular SSP connection reach 100 000 values of unique publisher id's
                      the platform will automatically stop recording requests and response statistics per publisher ids.
                      You may enable/disable writing publisher IDs per particular SSP connection inside the statistics at your sole discretion."
                      ></app-tooltip>
                    </label>
                    <nz-select
                      nzShowSearch
                      nzPlaceHolder="Select Writing Publisher IDs"
                      formControlName="writing_pub_ids"
                      name="writing_pub_ids"
                    >
                      <nz-option
                        *ngFor="let item of editSspService.pubWritingItems"
                        [nzValue]="item.id"
                        [nzLabel]="item.name"
                      ></nz-option>
                    </nz-select>
                  </div>

                  <div class="check-tooltip">
                    <label
                      nz-checkbox
                      formControlName="has_new_iab_categories"
                      name="has_new_iab_categories"
                      (ngModelChange)="
                        editSspService.onChangeIABCategoriesCheckboxStateHandler(
                          $event
                        )
                      "
                      >IAB Categories</label
                    >
                  </div>

                  <div
                    class="form-group"
                    *ngIf="editSspService.formValue.has_new_iab_categories"
                  >
                    <div class="checkbox">
                      <label>
                        IAB Categories
                        <app-tooltip
                          tooltipTitle="Choose the IAB Categories that represent your supply"
                        ></app-tooltip>
                      </label>
                      <nz-tree-select
                        name="iab_cat"
                        nzPlaceHolder="Select IAB Categories"
                        formControlName="iab_cat"
                        [nzMaxTagCount]="3"
                        [nzMaxTagPlaceholder]="omittedPlaceHolder"
                        [nzNodes]="editSspService.iabCategories"
                        [nzAllowClear]="false"
                        [nzShowSearch]="true"
                        [nzMultiple]="true"
                        nzVirtualHeight="250px"
                        nzCheckable
                      ></nz-tree-select>
                      <ng-template #omittedPlaceHolder let-omittedValues
                        >and {{ omittedValues.length }} more...</ng-template
                      >
                    </div>
                  </div>

                  <div class="check-tooltip">
                    <label
                      nz-checkbox
                      formControlName="is_flexible_size_matching"
                      name="is_flexible_size_matching"
                      >Flexible size matching</label
                    >
                    <app-tooltip
                      tooltipTitle="Enables processing of bid responses with creatives that are smaller than or equal to the bid request size dimensions."
                    ></app-tooltip>
                  </div>

                  <div class="check-tooltip">
                    <label
                      nz-checkbox
                      formControlName="is_multi_ad_response"
                      name="is_multi_ad_response"
                      >Multi-bid response logic</label
                    >
                    <app-tooltip
                      tooltipTitle="When enabled, Multi-bid response logic will activate on the SSP endpoint, allowing multiple creatives/bids to be returned in a single SSP response instead of only one winning creative."
                    ></app-tooltip>
                  </div>

                  <div
                    class="form-group"
                    *ngIf="editSspService.formValue.is_multi_ad_response"
                  >
                    <label for="endpointSSPMultiAdResponsesEdit2"
                      >Maximum Bids per response
                      <app-tooltip
                        tooltipTitle="Defines the maximum number of bids allowed in a single response. Allowed values: from 2 to 10"
                      ></app-tooltip>
                    </label>
                    <input
                      nz-input
                      type="number"
                      id="endpointSSPMultiAdResponsesEdit2"
                      name="multi_ad_responses"
                      formControlName="multi_ad_responses"
                      class="form-control"
                      min="2"
                      max="10"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="editSspService.tabIndex === 3">
          <div class="row" formGroupName="vast">
            <div class="col-6">
              <!-- Rewarded -->
              <div class="form-group vast-ext-row vast-ext-row--switch">
                <div class="vast-ext-row__label">
                  <span>Rewarded</span>
                  <app-tooltip
                    tooltipTitle="Activates rewarded video handling and fallback signalling."
                  ></app-tooltip>
                </div>
                <div class="vast-ext-row__control">
                  <nz-switch
                    formControlName="is_rewarded"
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      editSspService.restrictionTooltipForVastExtensions()
                    "
                    nzTooltipPlacement="top"
                  ></nz-switch>
                </div>
              </div>

              <div class="form-group">
                <label>
                  Skip
                  <app-tooltip
                    tooltipTitle="Allows users to skip the video ad"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzPlaceHolder="Select Skip"
                  formControlName="skip"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editSspService.restrictionTooltipForVastExtensions()
                  "
                  nzTooltipPlacement="top"
                >
                  <nz-option
                    *ngFor="let item of editSspService.skipItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>

              <div
                class="form-group form-group_inline"
                *ngIf="editSspService.isShowSkipFields()"
              >
                <div class="row">
                  <div class="col-6">
                    <label>
                      Skip Min
                      <app-tooltip
                        tooltipTitle="Minimum video length (sec) for it to be skipped"
                      ></app-tooltip>
                    </label>
                    <input
                      nz-input
                      type="number"
                      class="form-control"
                      formControlName="skipmin"
                      nz-tooltip
                      nzTooltipOverlayClassName="item-tooltip"
                      [nzTooltipTitle]="
                        editSspService.restrictionTooltipForVastExtensions()
                      "
                      nzTooltipPlacement="top"
                    />
                  </div>
                  <div class="col-6">
                    <label>
                      Skip After
                      <app-tooltip
                        tooltipTitle="Seconds until the skip button appears"
                      ></app-tooltip>
                    </label>
                    <input
                      nz-input
                      type="number"
                      class="form-control"
                      formControlName="skipafter"
                      nz-tooltip
                      nzTooltipOverlayClassName="item-tooltip"
                      [nzTooltipTitle]="
                        editSspService.restrictionTooltipForVastExtensions()
                      "
                      nzTooltipPlacement="top"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group form-group_inline">
                <div class="row">
                  <div class="col-6">
                    <label>
                      Min Duration
                      <app-tooltip
                        tooltipTitle="Minimum allowed video ad length in seconds"
                      ></app-tooltip>
                    </label>
                    <input
                      nz-input
                      type="number"
                      class="form-control"
                      formControlName="minduration"
                      nz-tooltip
                      nzTooltipOverlayClassName="item-tooltip"
                      [nzTooltipTitle]="
                        editSspService.restrictionTooltipForVastExtensions()
                      "
                      nzTooltipPlacement="top"
                    />
                  </div>
                  <div class="col-6">
                    <label>
                      Max Duration
                      <app-tooltip
                        tooltipTitle="Maximum allowed video ad length in seconds"
                      ></app-tooltip>
                    </label>
                    <input
                      nz-input
                      type="number"
                      class="form-control"
                      formControlName="maxduration"
                      nz-tooltip
                      nzTooltipOverlayClassName="item-tooltip"
                      [nzTooltipTitle]="
                        editSspService.restrictionTooltipForVastExtensions()
                      "
                      nzTooltipPlacement="top"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>
                  Start Delay
                  <app-tooltip
                    tooltipTitle="Ad placement timing in the video content"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzPlaceHolder="Select Start Delay"
                  formControlName="startdelay"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editSspService.restrictionTooltipForVastExtensions()
                  "
                  nzTooltipPlacement="top"
                >
                  <nz-option
                    *ngFor="let item of editSspService.startDelayItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>

              <div
                class="form-group"
                *ngIf="editSspService.isShowStartDelayMidControls()"
              >
                <label for="startdelay">Mid-roll Delay</label>
                <input
                  nz-input
                  type="number"
                  class="form-control"
                  formControlName="startdelaymid"
                />
              </div>

              <div class="form-group">
                <label>
                  Placement
                  <app-tooltip
                    tooltipTitle="Video ad placement type (OpenRTB 2.5)"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzPlaceHolder="Select Placement"
                  formControlName="placement"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editSspService.restrictionTooltipForVastExtensions()
                  "
                  nzTooltipPlacement="top"
                >
                  <nz-option
                    *ngFor="let item of editSspService.placementItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>

              <div class="form-group">
                <label>
                  Plcmt
                  <app-tooltip
                    tooltipTitle="Video ad placement type (OpenRTB 2.6)"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzPlaceHolder="Select Plcmt"
                  formControlName="plcmt"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editSspService.restrictionTooltipForVastExtensions()
                  "
                  nzTooltipPlacement="top"
                >
                  <nz-option
                    *ngFor="let item of editSspService.plcmtItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>
                  Mimes
                  <app-tooltip
                    tooltipTitle="Supported media file formats"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzMode="tags"
                  nzPlaceHolder="Select Mimes"
                  formControlName="mimes"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editSspService.restrictionTooltipForVastExtensions()
                  "
                  nzTooltipPlacement="top"
                >
                  <nz-option
                    *ngFor="let item of editSspService.mimesItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>

              <div class="form-group">
                <label>
                  Position
                  <app-tooltip
                    tooltipTitle="Ad position on the page layout"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzPlaceHolder="Select Position"
                  formControlName="pos"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editSspService.restrictionTooltipForVastExtensions()
                  "
                  nzTooltipPlacement="top"
                >
                  <nz-option
                    nzCustomContent
                    *ngFor="let item of editSspService.positionItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  >
                    <span
                      nz-tooltip
                      nzTooltipOverlayClassName="item-tooltip"
                      [nzTooltipTitle]="item.desc"
                      nzTooltipPlacement="top"
                      >{{ item.name }}
                    </span>
                  </nz-option>
                </nz-select>
              </div>

              <div class="form-group">
                <label>
                  Playback methods
                  <app-tooltip
                    tooltipTitle="Video autoplay and sound behavior"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzMode="multiple"
                  nzPlaceHolder="Select Playback methods"
                  formControlName="playbackmethod"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editSspService.restrictionTooltipForVastExtensions()
                  "
                  nzTooltipPlacement="top"
                >
                  <nz-option
                    *ngFor="let item of editSspService.playbackmethodItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>

              <div class="form-group">
                <label>
                  Protocols
                  <app-tooltip
                    tooltipTitle="Supported ad response protocols and versions"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzMode="multiple"
                  nzPlaceHolder="Select Protocols"
                  formControlName="protocols"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editSspService.restrictionTooltipForVastExtensions()
                  "
                  nzTooltipPlacement="top"
                >
                  <nz-option
                    *ngFor="let item of editSspService.protocolsItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>

              <div class="form-group">
                <label>
                  API Frameworks
                  <app-tooltip
                    tooltipTitle="Supported ad API frameworks"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzMode="multiple"
                  nzPlaceHolder="Select API Frameworks"
                  formControlName="api"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editSspService.restrictionTooltipForVastExtensions()
                  "
                  nzTooltipPlacement="top"
                >
                  <nz-option
                    *ngFor="let item of editSspService.apiProtocolsItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="editSspService.tabIndex === 4">
          <div class="col-6">
            <div class="form-title">Others</div>
            <div class="other-wrap">
              <div class="form-group">
                <label for="emailSSPEdit">Contact Email</label>
                <input
                  nz-input
                  class="form-control"
                  id="emailSSPEdit"
                  name="email"
                  email
                  type="email"
                  formControlName="email"
                />
              </div>
              <div class="form-group">
                <label for="commentsSSPEdit">Comment</label>
                <input
                  nz-input
                  class="form-control"
                  id="commentsSSPEdit"
                  name="comments"
                  formControlName="comments"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *nzModalFooter class="form-bottom">
      <div class="form-bottom__buttons">
        <div class="buttons-block">
          <span
            class="buttons-block__item"
            nz-tooltip
            nzTooltipOverlayClassName="item-tooltip"
            [nzTooltipTitle]="
              editSspService.restrictionTooltipMessageForButton(
                editSspService.formValue.connectionType
              )
            "
          >
            <button
              type="submit"
              nz-button
              nzType="primary"
              [disabled]="editSspService.isDisabledSubmitBtn"
              (click)="onSubmitForm()"
            >
              Save
            </button>
          </span>
          <span class="buttons-block__item">
            <button
              type="button"
              nz-button
              class="btn-cancel"
              nzType="default"
              (click)="onCloseModal()"
            >
              Cancel
            </button>
          </span>
        </div>
        <ng-container *ngIf="!editSspService.isUserViewer">
          <div
            class="icons-block"
            [style.width]="
              !editSspService.formValue.deletedAt ? '70px' : 'auto'
            "
          >
            <button
              buttonLabel="duplicateEndpointSSP"
              nz-button
              nzType="text"
              (click)="onDuplicateEndpoint(editSspService.formValue['id'])"
              class="btn-duplicate"
              [disabled]="editSspService.isDisableDuplicate"
            >
              <span nz-icon class="icons-block__icon">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_12897_68458)">
                    <rect width="32" height="32" rx="4" fill="white" />
                    <rect
                      width="32"
                      height="32"
                      rx="4"
                      fill="url(#paint0_linear_12897_68458)"
                    />
                    <path
                      d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H28C29.933 0.5 31.5 2.067 31.5 4V28C31.5 29.933 29.933 31.5 28 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z"
                      stroke="#D8DDE6"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19.7894 7H9.68421C8.75789 7 8 7.77727 8 8.72727V20.8182H9.68421V8.72727H19.7894V7Z"
                      fill="#A8B7C7"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.0533 10.4551H22.3165C23.2428 10.4551 24.0007 11.2324 24.0007 12.1823V24.2733C24.0007 25.2233 23.2428 26.0005 22.3165 26.0005H13.0533C12.127 26.0005 11.3691 25.2233 11.3691 24.2733V12.1823C11.3691 11.2324 12.127 10.4551 13.0533 10.4551ZM13.0533 24.2731H22.3165V12.1822H13.0533V24.2731Z"
                      fill="#A8B7C7"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_12897_68458"
                      x1="16"
                      y1="0"
                      x2="16"
                      y2="32"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </linearGradient>
                    <clipPath id="clip0_12897_68458">
                      <rect width="32" height="32" rx="4" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </button>
            <span
              buttonLabel="deleteEndpointSSP"
              nz-icon
              (click)="onDeleteEndpoint(editSspService.formValue)"
              class="icons-block__icon"
              *ngIf="!editSspService.formValue.deletedAt"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_12897_68475)">
                  <rect width="32" height="32" rx="4" fill="white" />
                  <rect
                    width="32"
                    height="32"
                    rx="4"
                    fill="url(#paint0_linear_12897_68475)"
                  />
                  <path
                    d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H28C29.933 0.5 31.5 2.067 31.5 4V28C31.5 29.933 29.933 31.5 28 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z"
                    stroke="#D8DDE6"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 23C10 24.1 10.9 25 12 25H20C21.1 25 22 24.1 22 23V11H10V23Z"
                    fill="#A8B7C7"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M23 8H19.5L18.5 7H13.5L12.5 8H9V10H23V8Z"
                    fill="#A8B7C7"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_12897_68475"
                    x1="16"
                    y1="0"
                    x2="16"
                    y2="32"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                  <clipPath id="clip0_12897_68475">
                    <rect width="32" height="32" rx="4" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</form>
